import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CloudOff } from "lucide-react";
import { InfoBanner } from "@/components/patterns/info-banner";
import { getNetworkState, onNetworkChange } from "@/app/platform";

/**
 * A home-screen icon promises more than a browser tab does, and this app cannot keep that
 * promise yet: with nothing cached, no signal means no data. Saying so is the difference
 * between "the app is broken" and "I'm in a lift".
 */
export function OfflineBanner() {
  const { t } = useTranslation();
  const [online, setOnline] = useState(true);

  useEffect(() => {
    void getNetworkState().then((s) => setOnline(s.online));
    return onNetworkChange((s) => setOnline(s.online));
  }, []);

  if (online) return null;

  /**
   * ⚠️ A DECISION: the design system's capture leaves the offline state undecided (13.5),
   * so this reuses its banner pattern rather than inventing a second visual language for
   * "something is wrong".
   */
  return (
    <div role="status" className="px-4 pt-3">
      <InfoBanner leading={<CloudOff />} title={t("offline.banner")} />
    </div>
  );
}
